import store from '../store';

export default (route) => {
    const { rota: { rotas } } = store.getState();

    return rotas.some(rota => !rota.permitido && rota.path === route);
}